import { defineComponent as h, openBlock as o, createElementBlock as e, mergeProps as u, unref as a, renderSlot as i, createElementVNode as n, createCommentVNode as H } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, k = { key: 2 }, A = { key: 3 }, M = { key: 4 }, Z = { key: 5 }, w = {
  name: "ScalarIconSupersetProperOf"
}, V = /* @__PURE__ */ h({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = g(s);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      i(p.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", m, t[0] || (t[0] = [
        n("path", { d: "M228,128a92.1,92.1,0,0,1-92,92H64a12,12,0,0,1,0-24h72a68,68,0,0,0,0-136H64a12,12,0,0,1,0-24h72A92.1,92.1,0,0,1,228,128Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M216,128a80,80,0,0,1-80,80H64V48h72A80,80,0,0,1,216,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,128a88.1,88.1,0,0,1-88,88H64a8,8,0,0,1,0-16h72a72,72,0,0,0,0-144H64a8,8,0,0,1,0-16h72A88.1,88.1,0,0,1,224,128Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,192H80a8,8,0,0,1,0-16h48a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h48a64,64,0,0,1,0,128Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", A, t[3] || (t[3] = [
        n("path", { d: "M222,128a86.1,86.1,0,0,1-86,86H64a6,6,0,0,1,0-12h72a74,74,0,0,0,0-148H64a6,6,0,0,1,0-12h72A86.1,86.1,0,0,1,222,128Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        n("path", { d: "M224,128a88.1,88.1,0,0,1-88,88H64a8,8,0,0,1,0-16h72a72,72,0,0,0,0-144H64a8,8,0,0,1,0-16h72A88.1,88.1,0,0,1,224,128Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", Z, t[5] || (t[5] = [
        n("path", { d: "M220,128a84.09,84.09,0,0,1-84,84H64a4,4,0,0,1,0-8h72a76,76,0,0,0,0-152H64a4,4,0,0,1,0-8h72A84.09,84.09,0,0,1,220,128Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  V as default
};
